import { Link } from "@/src/navigation";

interface INavLink {
  id: number;
  route: string;
  text: string;
}

interface NavLinkProps {
  link: INavLink;
  handleLinkClick: () => void;
  setIsMenuOpen: (isOpen: boolean) => void;
  isActive?: boolean;
}

const NavLink = ({
  link,
  handleLinkClick,
  setIsMenuOpen,
  isActive = false,
}: NavLinkProps) => {
  return (
    <li>
      <button className="hidden lg:block">
        <Link
          href={link.route}
          onClick={() => {
            handleLinkClick();
            setIsMenuOpen(false);
          }}
          className={`text-text-primary lg:text-sm xl:text-base hover:text-accent transition-colors pb-1 cursor-pointer nav-link-border ${
            isActive ? "text-accent! nav-link-active" : ""
          }`}
        >
          {link.text}
        </Link>
      </button>

      <button className="lg:hidden w-full">
        <Link
          href={link.route}
          onClick={handleLinkClick}
          className={`block button2 px-5 py-3 text-text-primary hover:text-accent hover:bg-background transition-colors ${
            isActive ? "text-accent! bg-background nav-link-active-mobile" : ""
          }`}
        >
          {link.text}
        </Link>
      </button>
    </li>
  );
};

export default NavLink;
